import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const PortalContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api/homeowner`;

export function PortalProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('hdh_portal_token'));
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data);
    } catch { localStorage.removeItem('hdh_portal_token'); setToken(null); setUser(null); }
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchUser(); }, [fetchUser]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/login`, { email, password });
    localStorage.setItem('hdh_portal_token', res.data.token);
    setToken(res.data.token);
    const me = await axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${res.data.token}` } });
    setUser(me.data);
    return res.data;
  };

  const logout = () => { localStorage.removeItem('hdh_portal_token'); setToken(null); setUser(null); };

  const api = useCallback((path, opts = {}) => {
    return axios({ url: `${API}${path}`, headers: { Authorization: `Bearer ${token}` }, ...opts });
  }, [token]);

  return (
    <PortalContext.Provider value={{ user, token, login, logout, loading, api }}>
      {children}
    </PortalContext.Provider>
  );
}

export const usePortal = () => useContext(PortalContext);
